
import SortUtils from "../../SortUtils.js";
import { SubDomain } from "../../SubDomain.js";
import GpsPosition from "./GpsPosition.js";
import GpsPositionMap from "./GpsPositionMap.js";

export default class GpsPositionDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, GpsPosition.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }

  sort() {
    return this.list().sort(SortUtils.SortBy_createdDateZa);
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new GpsPosition(this.domain, item);
      }
    }

    var position = new GpsPosition(this.domain);
    position.withId(objId);
    return position;
  }

  findByGpsDevice(device) {
    var map = new GpsPositionMap(this.domain);
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      let position = new GpsPosition(this.domain, item);
      if (position.gpsDevice().id() === device.id()) {
        map.add(position);
      }
    }
    return map;
  }
}
